import { FiltersType, FilterType } from 'types/ProductListing/ProductListing';
import { useMemo } from 'react';
import { formatPrice } from 'services/formatter';

export default function useFilters(filters: FiltersType): FiltersType {
  return useMemo(() => {
    return {
      list: filters.list.map(filter => {
        if (filter.name === 'Prix') {
          return formatPriceFilterLabels(filter);
        }

        return filter;
      }),
      applied: filters.applied.map(apply => {
        if (apply.code === 'Prix') {
          return {
            ...apply,
            label: formatPriceLabel(apply.label),
          };
        }

        return apply;
      }),
    };
  }, [filters]);
}

function formatPriceFilterLabels(filter: FilterType) {
  const formattedValues = filter.values.map(value => ({
    ...value,
    label: formatPriceLabel(value.label),
  }));

  return {
    ...filter,
    values: formattedValues,
  };
}

function formatPriceLabel(label: string) {
  return label.replace(/(\d+(?:\.\d+)?)/g, match => {
    return formatPrice(match, true).replace(/\s+/g, '');
  });
}
